/** Gateway list may come back as a bare array or wrapped in a status envelope. */
function unwrapGateways(response) {
  if (Array.isArray(response)) return response
  if (response && typeof response === 'object' && Array.isArray(response.data)) return response.data
  return []
}

/**
 * Finds the active Razorpay gateway from GET /payment-gateways and pulls out
 * its public key id, trying the handful of field names backends commonly use
 * for this. Returns null if Razorpay isn't configured/active server-side —
 * callers should fall back to VITE_RAZORPAY_KEY (or fail gracefully) in that case.
 */
export function resolveRazorpayKey(response) {
  const gateways = unwrapGateways(response)
  const razorpay = gateways.find((g) => {
    const label = `${g.slug ?? ''} ${g.name ?? ''} ${g.title ?? ''} ${g.gateway_name ?? ''} ${g.display_name ?? ''}`.toLowerCase()
    return label.includes('razorpay')
  })
  if (!razorpay) return null
  if (razorpay.is_active === false || razorpay.is_active === 0) return null

  return (
    razorpay.key ??
    razorpay.key_id ??
    razorpay.public_key ??
    razorpay.api_key ??
    razorpay.config?.key ??
    razorpay.config?.key_id ??
    razorpay.credentials?.key ??
    razorpay.credentials?.key_id ??
    null
  )
}
